import React from 'react'
import { useSelector } from 'react-redux'

import Loader from '@/app/component/atom/loader'
import { useRequirePermission } from '@/app/module/user/store/ts/hooks'
import { selectUserLoading } from '@/app/module/user/store/ts/selectors'

import CallRecordingsListContainer from './call-recordings-list.container'
import NoReportPermission from './no-report-permission'

const CallRecordingsContainer: React.FC = () => {
  const hasPermission = useRequirePermission('downloadCallRecordings')
  const userLoading = useSelector(selectUserLoading)

  return (
    <>
      {!userLoading && !hasPermission && <NoReportPermission />}
      {hasPermission && <CallRecordingsListContainer />}
      {userLoading && <Loader />}
    </>
  )
}

export default CallRecordingsContainer
